module.exports = __webpack_public_path__ + "static/media/Niveau_elN6_1_551284.f7b32845.png";